const DAYS = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];

const WEEK = [
  { day: 0, tag: "圈内", tagCls: "bg-primary-100 text-primary-700", title: "某剧男二被扒同款行程，CP 营业变拆伙实锤？", time: "09:40", hot: "88.2k" },
  { day: 1, tag: "商界", tagCls: "bg-accent-100 text-accent-800", title: "本地连锁品牌换帅，加盟商群聊记录刷屏", time: "21:07", hot: "120.6k" },
  { day: 2, tag: "综艺", tagCls: "bg-secondary-100 text-secondary-800", title: "选秀回锅阵容内定名单遭泄，节目组急删帖", time: "14:22", hot: "77.9k" },
  { day: 3, tag: "圈内", tagCls: "bg-primary-100 text-primary-700", title: "顶流工作室发声明否认婚变，评论区翻车", time: "10:15", hot: "203.4k" },
  { day: 3, tag: "体育", tagCls: "bg-accent-100 text-accent-800", title: "主帅离任前发布会口误，被指暗讽球员", time: "18:33", hot: "45.1k" },
  { day: 4, tag: "网红", tagCls: "bg-secondary-100 text-secondary-800", title: "带货一哥翻车旧料被挖，删评控楼引热议", time: "12:58", hot: "156.3k" },
  { day: 5, tag: "圈内", tagCls: "bg-primary-100 text-primary-700", title: "颁奖礼同框无交流，昔日好友疑似疏远", time: "23:12", hot: "98.7k" },
  { day: 6, tag: "综艺", tagCls: "bg-secondary-100 text-secondary-800", title: "真人秀恶意剪辑片段流出，嘉宾喊话制片", time: "08:19", hot: "66.5k" },
  { day: 6, tag: "商界", tagCls: "bg-accent-100 text-accent-800", title: "高管被指利益输送，深夜发文回应全否认", time: "22:40", hot: "88.8k" },
];

export default function WeeklyFeed() {
  return (
    <section id="weekly" className="py-10 md:py-14 bg-background-100/60">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-7">
          <div>
            <p className="flex items-center gap-2 text-[13px] font-semibold text-primary-600 tracking-wide">
              <span className="w-1.5 h-3 rounded-sm bg-primary-500" />
              THIS WEEK · 2026.09.02 - 09.08
            </p>
            <h2 className="mt-2 font-heading text-[28px] md:text-[36px] font-black text-foreground-950">
              本周汇总<span className="text-primary-500"> · </span>速报流
            </h2>
            <p className="mt-2 text-[14px] text-foreground-500 max-w-[560px]">
              近 7 天按日归好档，短讯与卡片并行排布。想要一次看全本周的关键事件，从这里开翻最快。
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm">
            {DAYS.map((d, i) => (
              <span
                key={d}
                className={`w-8 h-8 rounded-md flex items-center justify-center text-[12px] font-semibold ${
                  i === 4 ? "bg-primary-500 text-background-50" : "bg-background-50 border border-background-200 text-foreground-600"
                }`}
              >
                {d}
              </span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {WEEK.map((w, idx) => (
            <a
              key={idx}
              href="#recap"
              className="group bg-background-50 rounded-lg border border-background-200 p-4 md:p-5 hover:border-primary-200 hover:-translate-y-0.5 transition-all"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className={`rounded-full px-2.5 py-0.5 text-[12px] font-semibold ${w.tagCls}`}>{w.tag}</span>
                <span className="text-[12px] text-foreground-400">周{DAYS[w.day]}</span>
                <span className="ml-auto flex items-center gap-1 text-[12px] text-foreground-400">
                  <i className="ri-fire-line w-3.5 h-3.5 text-accent-500" /> {w.hot}
                </span>
              </div>
              <h3 className="text-[15px] md:text-[16px] leading-snug font-semibold text-foreground-900 group-hover:text-primary-700 line-clamp-2 transition-colors">
                {w.title}
              </h3>
              <div className="mt-3 flex items-center gap-2 text-[12px] text-foreground-400">
                <i className="ri-time-line w-3.5 h-3.5" /> {w.time} 更新
                <span className="ml-auto group-hover:text-primary-600 font-medium">展开 &gt;</span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 flex justify-center">
          <a
            href="#timeline"
            className="inline-flex items-center gap-2 rounded-md bg-background-50 border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-700 hover:bg-primary-50 hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
          >
            本周还没看够？去时间线补课
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center" />
          </a>
        </div>
      </div>
    </section>
  );
}